module.exports = __webpack_public_path__ + "img/21.0f7f5a70.jpg";